import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import LandingPage from './sites/business-solutions/LandingPage';
import AssessmentWizard from './sites/business-solutions/AssessmentWizard';
import ExtractionForm from './sites/business-solutions/ExtractionForm';
import AboutUs from './sites/about-us/AboutUs';
import ChatbotDemo from './sites/business-solutions/ChatbotDemo';
import DIO from './sites/business-solutions/DIO';
// Import Chatbot site components
import ChatbotLanding from './sites/chatbot/LandingPage';
// Import new HomePage component
import HomePage from './sites/home/HomePage';
import AISolutions from './sites/ai-solutions/LandingPage';
import Automation from './sites/automation/LandingPage';
import Dashboards from './sites/dashboards/LandingPage';

const App = () => {
    const [currentPath, setCurrentPath] = useState(window.location.pathname);

    useEffect(() => {
        const handlePopState = () => {
            setCurrentPath(window.location.pathname);
        };
        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, []);

    const handleNavigate = (path) => {
        window.history.pushState({}, '', path);
        setCurrentPath(path);
        window.scrollTo(0, 0);
    };

    const renderComponent = () => {
        // Check if path starts with /chatbots
        if (currentPath.startsWith('/chatbots')) {
            return <ChatbotLanding onNavigate={handleNavigate} />;
        }

        // Business Solutions routes
        switch (currentPath) {
            case '/':
                return <HomePage onNavigate={handleNavigate} />;
            case '/business-solutions':
                return <LandingPage onNavigate={handleNavigate} />;
            case '/about':
                return <AboutUs onNavigate={handleNavigate} />;
            case '/assessment':
                return <AssessmentWizard onNavigate={handleNavigate} />;
            case '/contact':
                return <ExtractionForm onNavigate={handleNavigate} />;
            case '/chatbot-demo':
                return <ChatbotDemo onNavigate={handleNavigate} />;
            case '/automation':
                return <Automation onNavigate={handleNavigate} />; // Placeholder - replace with actual component when available
            case '/dashboards':
                return <Dashboards onNavigate={handleNavigate} />; // Placeholder - replace with actual component when available
            case '/ai-chatbots':
                return <ChatbotLanding onNavigate={handleNavigate} />; // Redirect to chatbot landing
            case '/ai-solutions':
                return <AISolutions onNavigate={handleNavigate} />; // Placeholder - replace with actual component when available
            case '/security':
                return <LandingPage onNavigate={handleNavigate} />; // Placeholder - replace with actual component when available
            default:
                return <HomePage onNavigate={handleNavigate} />;
        }
    };

    // Determine if the footer (DIO component) should be shown
    const shouldShowFooter = () => {
        return !currentPath.startsWith('/chatbots') &&
            currentPath !== '/chatbot-demo' &&
            currentPath !== '/'; // Don't show on the HomePage
    };

    return (
        <div className="bg-slate-900 min-h-screen">
            <Navbar onNavigate={handleNavigate} currentPath={currentPath} />
            {renderComponent()}
            {shouldShowFooter() && <DIO />}
        </div>
    );
};

export default App;